import { combineReducers } from "redux";
import bets from "../features/admin/funtarget/bets/slice";
import result from "../features/admin/funtarget/result/slice";
import winner from "../features/admin/funtarget/winner/slice";

const funTarget = combineReducers({
  bets: bets,
  result: result,
  winner: winner,
});

export default funTarget;
